import { render, staticRenderFns } from "./EditUserInUsergroupDialog.vue?vue&type=template&id=1a3c5bbc&scoped=true&lang=pug"
import script from "./EditUserInUsergroupDialog.vue?vue&type=script&lang=js"
export * from "./EditUserInUsergroupDialog.vue?vue&type=script&lang=js"
import style0 from "./EditUserInUsergroupDialog.vue?vue&type=style&index=0&id=1a3c5bbc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c5bbc",
  null
  
)

export default component.exports